import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../store/actions/dataActions';



//charts
import { Line, defaults } from 'react-chartjs-2';


class Player extends Component {

    constructor(props) {
        super(props);

      
        

      
    }

   
componentDidMount() {
    // This method is called when the component is first added to the document
   
}

componentDidUpdate() {
  
}

ensureDataFetched() {
    const startDateIndex = parseInt(this.props.match.params.startDateIndex, 10) || 0;
    // this.props.requestWeatherForecasts(startDateIndex);
    this.props.getData();
 
}

render() {
    const access = localStorage.getItem("accessToken");
    console.info(this.props.audioURL);
    let url = this.props ? this.props.audioURL : '';
    return (
        <div>
            <audio onEnded={(e) => console.info(e)} controls src={url && url !="" ?  "/api/data/getaudio?fugaid=" + url + "&access_token=" + access : ""} autoPlay filename="alfa.mp3"></audio>  
        
        </div>
    );
}
}






export default connect(
    state => state.data,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Player);



// WEBPACK FOOTER //
// ./src/components/player.js